import { Component } from '@angular/core';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
    standalone: false
})
export class AccessDeniedComponent {

  constructor() {
  }

}
